import React, { useEffect } from 'react';
import { getUserManagerAsync } from '../Components/OidcConfig';
import logo from '../logo.svg';

const OidcCallbackPage = () => {

    useEffect(() => {
        handleCallback();
    }, []);

    return (
        <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <p>
            Getting user information...
          </p>
        </header>
      </div>);
};


const handleCallback = async () => {
    const userManager = await getUserManagerAsync();

    try {
        console.log("Processing authentication callback...");
        await userManager.signinRedirectCallback();

        // Retrieve user info and tokens
        const user = await userManager.getUser();

        // Access token
        const accessToken = user?.access_token;
        console.log("Access token:", accessToken);
        if (accessToken) {
            window.location.href = '/new-consultation';  // Using window.location for full page redirect
        }
    } catch (error) {
        console.error("Error during callback:", error);
    }
};

export default OidcCallbackPage;